// extracted by mini-css-extract-plugin
export var bottomBoundary = "styles-module--bottomBoundary--V5PjQ";
export var content = "styles-module--content--JzCLt";